import React from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import {getCompanyBySiret} from "../../api/company";
import LinearProgress from '@material-ui/core/LinearProgress';

function renderInputComponent(inputProps) {
    const { classes, inputRef = () => {}, ref, ...other } = inputProps;

    return (
        <TextField
            fullWidth
            InputProps={{
                inputRef: node => {
                    ref(node);
                    inputRef(node);
                },
                classes: {
                    input: classes.input,
                },
            }}
            {...other}
        />
    );
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
    const matches = match(suggestion.label, query);
    const parts = parse(suggestion.label, matches);
    return (
        <MenuItem selected={isHighlighted} component="div">
            <div>
                {parts.map((part, index) => {
                    return part.highlight ? (
                        <span key={String(index)} style={{ fontWeight: 500 }}>
              {part.text}
            </span>
                    ) : (
                        <strong key={String(index)} style={{ fontWeight: 300 }}>
                            {part.text}
                        </strong>
                    );
                })}
            </div>
        </MenuItem>
    );
}

function getSuggestionValue(suggestion) {
    return suggestion.label;
}

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    container: {
        position: 'relative',
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    },
    divider: {
        height: theme.spacing.unit * 2,
    },
    linearProgress: {
        marginTop: 5,
    },
});

class AutoSuggestSiret extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            single: '',
            popper: '',
            suggestions: [],
            progress: false,
        };

    }


    handleSuggestionsFetchRequested = ({ value }) => {
        this.setState({suggestions: this.props.options ? this.props.options.map(option => {
            return {'id': option.id, 'label': option.name, 'siret': option.siret}
        }) : []})
    };

    handleSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    };

    handleChange = name => (event, { newValue }) => {
        var _this = this;
        const organisation = this.state.suggestions.find(option => option.label === newValue);
        if(organisation && this.props.completeForm){
            this.setState({
                single: organisation.siret.replace(/ /g,''),
                progress: true,
            }, () => {
                getCompanyBySiret(organisation.siret.replace(/ /g,'')).then(res => {
                    if(res && !('error' in res)){
                        _this.props.completeForm(res)
                    }
                    _this.setState({progress: false})
                }).catch(err => {
                    _this.setState({progress: false})
                })
            });
        }else {
            this.setState({
                [name]: newValue.replace(/ /g,''),
                progress: true,
            }, () => {
                if(name === "single" && newValue.length >= 9){
                    getCompanyBySiret(newValue.replace(/ /g,'')).then(res => {
                        if(res && !('error' in res)){
                            _this.props.completeForm(res)
                        }
                        _this.setState({progress: false})
                    }).catch(err => {
                        _this.setState({progress: false})
                    })
                }else{
                    _this.setState({progress: false})
                }
            });
        }
    };

    componentWillReceiveProps(nextProps){
        if(nextProps.options && nextProps.options.length > 0){
            this.setState({suggestions: nextProps.options.map(option => {
                return {'id': option.id, 'label': option.name, 'siret': option.siret}
            })})
        }
    }

    render() {
        const { classes } = this.props;

        const autosuggestProps = {
            renderInputComponent,
            suggestions: this.state.suggestions,
            onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
            onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
            getSuggestionValue,
            renderSuggestion,
        };

        return (
            <div className={classes.root}>
                <Autosuggest
                    {...autosuggestProps}
                    inputProps={{
                        classes,
                        placeholder: this.props.default ? this.props.default : 'Recherche par Siren/Siret',
                        value: this.state.single,
                        onChange: this.handleChange('single'),
                    }}
                    theme={{
                        container: classes.container,
                        suggestionsContainerOpen: classes.suggestionsContainerOpen,
                        suggestionsList: classes.suggestionsList,
                        suggestion: classes.suggestion,
                    }}
                    renderSuggestionsContainer={options => (
                        <Paper {...options.containerProps} square>
                            {options.children}
                        </Paper>
                    )}
                />
                {this.state.progress && <LinearProgress className={classes.linearProgress}/>}
            </div>
        );
    }
}

AutoSuggestSiret.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AutoSuggestSiret);


// WEBPACK FOOTER //
// ./src/component/utils/AutoSuggestSiret.js